var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        _vm.$route.params.slug ? _vm.$route.params.slug : "main",
        { activeRtl: _vm.$store.state.rtl },
        _vm.$route.name,
        _vm.isHalloween && _vm.isEventAllowedOnPage ? "halloween" : "",
        _vm.isChristmas && _vm.isEventAllowedOnPage ? "christmas" : "",
        _vm.isEaster && _vm.isEventAllowedOnPage ? "easter" : ""
      ],
      attrs: { id: "app" }
    },
    [
      _vm.isLuckyWheelEnabled ? _c("lucky-wheel") : _vm._e(),
      _vm.$store.state.maintenanceMode
        ? _c("maintenance-mode")
        : _vm.$store.state.errorMode
        ? _c("error-mode")
        : _c("app-content"),
      _vm.isHalloween &&
      !_vm.$store.state.errorMode &&
      !_vm.$store.state.maintenanceMode
        ? _c("event-halloween")
        : _vm._e(),
      _vm.isChristmas &&
      !_vm.$store.state.errorMode &&
      !_vm.$store.state.maintenanceMode
        ? _c("event-christmas")
        : _vm._e(),
      _vm.isEaster &&
      !_vm.$store.state.errorMode &&
      !_vm.$store.state.maintenanceMode
        ? _c("event-easter")
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }